export default "__VITE_ASSET__CueISJFR__"